import LocalStorage from "./localStorage";

const Console = {
  log(...args) {
    if (LocalStorage.getAdminMode() || process.env.NODE_ENV !== 'production') {
      console.log(...args);
    }
  },
  info(...args) {
    if (LocalStorage.getAdminMode() || process.env.NODE_ENV !== 'production') {
      console.info(...args);
    }
  },
  
  warn(...args) {
    if (LocalStorage.getAdminMode() || process.env.NODE_ENV !== 'production') {
      console.warn(...args);
    }
  },
  
  error(...args) {
    if (LocalStorage.getAdminMode() || process.env.NODE_ENV !== 'production') {
      console.error(...args);
    }
  },
  
  alert(...args) {
    if (LocalStorage.getAdminMode() || process.env.NODE_ENV !== 'production') {
      alert(...args)
    }
  },
};

export default Console;
